<template>
  <div>
    <div>
      <p class="ma-0 font-weight-medium">
        Previsão de gatilho
      </p>
      <p class="ma-0 mt-n1">
        {{ `${Helpers.formatarValor(detalhamento_categoria.previsao_gatilho)} dias` }}
        <v-icon small class="mt-n1" @click="dialog_ativo = true">mdi-pencil</v-icon>
      </p>
    </div>

    <v-dialog
      v-model="dialog_ativo"
      width="400"
      content-class="bra-20"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-card-title>
          <span>Previsão de gatilho</span>

          <v-spacer />

          <v-btn icon @click="dialog_ativo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-5">
          <TextFieldFormatadorDeValor
            v-model="previsao_gatilho"
            outlined
            :max-digitos="0"
            inteiro
            label="Qtd. dias"
            suffix="dias"
            :error-messages="PREVISAO_GATILHO_ERRORS"
            @focus="$event.target.select()"
            @keyup.enter="salvarPrevisaoGatilho()"
          />
        </v-card-text>

        <v-card-actions class="mt-n5">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="salvarPrevisaoGatilho()"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
import TextFieldFormatadorDeValor from '../../../utils/TextFieldFormatadorDeValor.vue';
import {required, minValue} from "vuelidate/lib/validators";
import {mapGetters} from "vuex";
import {salvarPrevisaoGatilho} from "../../../../api/compraPorDepartamentos/Categoria";
import {logout} from "../../../../helpers";

export default {
  name: "PrevisaoGatilho",
  components: { TextFieldFormatadorDeValor },
  props: {
    detalhamento_categoria: Object
  },
  data: () => ({
    dialog_ativo: false,
    previsao_gatilho: 0
  }),
  validations: {
    previsao_gatilho: {
      required,
      minValue: minValue(1),
    }
  },
  computed: {
    ...mapGetters({
      'callbackAtualizarTabelaCategorias': 'comprasPorDepartamentos/callbackAtualizarTabelaCategorias',
      'callbackAtualizarCardsTotais': 'comprasPorDepartamentos/callbackAtualizarCardsTotais',
      'callbackAtualizarDetalhesCategoria': 'comprasPorDepartamentos/callbackAtualizarDetalhesCategoria',
    }),
    PREVISAO_GATILHO_ERRORS() {
      const errors = [];
      if (!this.$v.previsao_gatilho.$dirty) return errors;
      !this.$v.previsao_gatilho.required && errors.push("Campo Obrigatório.");
      !this.$v.previsao_gatilho.minValue && errors.push("Valor mínimo é 1.");
      return errors;
    }
  },
  watch: {
    dialog_ativo(valor) {
      if (valor) {
        const obj = Object.assign({}, this.detalhamento_categoria);
        this.previsao_gatilho = obj.previsao_gatilho;
      }
    }
  },
  methods: {
    salvarPrevisaoGatilho() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const parametros = {
        idcategoria: this.detalhamento_categoria.idcategoria,
        previsao_gatilho: parseInt(this.previsao_gatilho)
      };

      this.$store.dispatch('loading/addRequisicao',
        salvarPrevisaoGatilho(parametros)
          .then(() => {
            this.dialog_ativo = false;
            this.callbackAtualizarTabelaCategorias();
            this.callbackAtualizarCardsTotais();
            this.callbackAtualizarDetalhesCategoria();
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>

</style>
